export const RESET_PASSWORD_USER_START = 'RESET_PASSWORD_USER_START';
export const RESET_PASSWORD_USER_SUCCESS =
  'RESET_PASSWORD_USER_SUCCESS';
export const RESET_PASSWORD_USER_ERROR = 'RESET_PASSWORD_USER_ERROR';
